import { DownloadEnum, USB_NAME, USB_NAME_PLAY_PATH, MIN_FREE_STORAGE_MB } from './playerEnum';
import { VERSION, CLIENT_ID } from '../pages/utils';

const TAG = '[BD-Cache]';

export default class Download {
  constructor(config) {
    console.log('Config : ', config);
    this.config = config;
    this.internalPath = 'file://internal/Blackdove/';
    this.staticInternalPath = 'file://internal/Blackdove/';
    this.fileName = this.getFileName();
    this.artworkName = this.getArtName();
    this.offlineFilesList = [];
    this.protectedIds = new Set();
    this.g_storage = new Storage();
    this.power = new Power();
    this.custom = new Custom();
    this.isDownloadProgress = false;
    this.downloadStatusInternal = null;
    this.isUSB = false; 
    this.ticket = 0;
    this.percentage = 0;
    this.received = 0;
    this.total = 0;
    this.downloadingCurrent = false;
    this.getUSBInformation();
    this.availableStorage = 0;
    this.mkdir();
    // this.addUSBAttachEventListener();
    this.quality4k = false;
    this.highQuality = false;
    this.appSpace = {
      freeInternal: 0,
      usedInternal: 0,
      freeExternal: 0,
      usedExternal: 0,
    }
  }

  formatBytes = (bytes) => {
    let marker = 1024; // Change to 1000 if required
    let decimal = 2; // Change as required
    let kiloBytes = marker; // One Kilobyte is 1024 bytes
    let megaBytes = marker * marker; // One MB is 1024 KB
    // let gigaBytes = marker * marker * marker; // One GB is 1024 MB
    // var teraBytes = marker * marker * marker * marker; // One TB is 1024 GB

    // return bytes if less than a KB
    if(bytes < kiloBytes) return bytes + " Bytes";
    // return KB if less than a MB
    else if(bytes < megaBytes) return(bytes / kiloBytes).toFixed(decimal) + " KB";
    // return MB if less than a GB
    else return(bytes / megaBytes).toFixed(decimal) + " MB";
    // return GB if less than a TB
    // else return(bytes / gigaBytes).toFixed(decimal) + " GB";
  };

  formatGB = (kilobytes) => {
    let decimal = 2; // Change as required
    let gigaBytes = 1000000; // 1 GB = 1000000 KB
    
    return(kilobytes / gigaBytes).toFixed(decimal);
  };

  getUSBInformation = () => {
    const that = this;
    function successCb(cbObject) {
      if (cbObject.usbList.length >= 1) {
        let usbName = cbObject.usbList[0].usbName;
        console.log(TAG, `USB detected: ${usbName} (${cbObject.usbList.length} device(s))`);
        window.isUSB = true;
        that.isUSB = true;
        window.usbName = USB_NAME_PLAY_PATH[usbName];
        that.staticInternalPath = `file://${USB_NAME[usbName]}/list/me/`;
        console.log(TAG, `Switching cache to USB: ${that.staticInternalPath}`);
        console.log(TAG, 'Purging internal storage (USB takes over)');
        that.removeAllDownloadsInternal(key => {
          console.log(TAG, `Internal purge result: ${key}`);
        });
      } else {
        console.log(TAG, 'No USB detected - using internal storage');
      }
    }

    function failureCb(cbObject) {
      console.log(TAG, `USB detection failed: ${cbObject.errorText} - using internal storage`);
    }

    this.g_storage.getUSBInfo(successCb, failureCb);
  };

  mkdir = () => {
    var options = {};
    options.path = this.staticInternalPath;

    var successCb = function (cbObject) {
      console.log('A directory is created successfully.');
    };

    var failureCb = function (cbObject) {
      var errorCode = cbObject.errorCode;
      var errorText = cbObject.errorText;

      console.log(' Error Code [' + errorCode + ']: ' + errorText);
    };

    this.g_storage.mkdir(successCb, failureCb, options);
  };

  getFileName = () => {
    if(this.config){
      return this.config.id;
    }
  };

  getArtName = () => {
    if(this.isDownloadProgress){
      if(this.config){
        return `Downloading ${this.config.name}`;
      }else{
        return 'N/A';
      }
    }else{
      return "No downloading in progress"
    }
  };
 
  getDownloadUrl = () => {
    this.check4KResolution();
    const media = this.config.media?.video?.full;
    let url = media?.high?.mp4;
    let imgUrl = false;

    // Select resolution: UHD (4k) when highQuality is on and display supports it, otherwise FHD (high)
    if (this.quality4k && this.highQuality && media?.['4k']?.mp4) {
      url = media['4k'].mp4;
    }

    const urlArr = url.split(".");
    const urlformat = urlArr[urlArr.length - 1].split("?");
    if(urlformat[0] === "mp4"){
      imgUrl = false;
    }else{
      imgUrl = true;
    }

    const resolution = (this.quality4k && this.highQuality && media?.['4k']?.mp4) ? 'UHD' : 'FHD';
    console.log(TAG, `Download URL [${resolution}]: ${url}`);
    let result = {};
    result.url = url;
    result.imgUrl = imgUrl;
    return result;
  };

  getNextDownloadUrl = (durl) =>{
    this.check4KResolution();
    let url = durl.high.mp4;
    let imgUrl = false;

    // Select resolution: UHD (4k) when highQuality is on and display supports it, otherwise FHD (high)
    if (this.quality4k && this.highQuality && durl?.['4k']?.mp4) {
      url = durl['4k'].mp4;
    }

    const urlArr = url.split(".");
    const urlformat = urlArr[urlArr.length - 1].split("?");
    if(urlformat[0] === "mp4"){
      imgUrl = false;
    }else{
      imgUrl = true;
    }

    const resolution = (this.quality4k && this.highQuality && durl?.['4k']?.mp4) ? 'UHD' : 'FHD';
    console.log(TAG, `Download URL [${resolution}]: ${url}`);
    let result = {};
    result.url = url;
    result.imgUrl = imgUrl;
    return result;
  }

  updateConfig = (config) => {
    console.log(TAG, 'New Config : ', config);
    this.config = config;
    this.fileName = this.getFileName();
  };

  setProtectedIds = (ids) => {
    this.protectedIds = new Set(ids);
    console.log(TAG, `Protected IDs set: ${this.protectedIds.size} artworks`);
  };

  checkFileHeadLength = async (callback,highQuality,nextFile) => {
    let result;
    this.highQuality = highQuality;
    if(nextFile !== undefined){
      result = this.getNextDownloadUrl(nextFile.url)
    }
    else{
      result = this.getDownloadUrl();
    }

    if(result.imgUrl){
      callback(DownloadEnum.SHOW_STILL_IMAGE, result.url);
      return;
    }

    const response = await fetch(result.url, {
      method: 'HEAD',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'x-bd-client-id': `${CLIENT_ID}`,
        'x-bd-client-version': `${VERSION}`,
      },
    });
    const contentLength = parseInt(response.headers.get('content-length'), 10) || 0;
    const floorBytes = MIN_FREE_STORAGE_MB * 1024 * 1024;
    const spaceAfterDownload = this.availableStorage - contentLength;
    const availMB = (this.availableStorage / (1024 * 1024)).toFixed(1);
    const fileMB = (contentLength / (1024 * 1024)).toFixed(1);
    const afterMB = (spaceAfterDownload / (1024 * 1024)).toFixed(1);
    console.log(TAG, `HEAD: file=${fileMB} MB, available=${availMB} MB, after download=${afterMB} MB, floor=${MIN_FREE_STORAGE_MB} MB`);
    if(spaceAfterDownload > floorBytes) {
      callback(DownloadEnum.CONTINUE_DOWNLOAD);
    } else {
      callback(DownloadEnum.GOTO_NEXT_ARTWORK);
    }
  };

  startDownload = (callback,highQuality,nextFile) => {
    const that = this;
    that.highQuality = highQuality;
    if(nextFile !== undefined){
      console.log('Start next Artwork Download');
    }else{
      console.log('Start Video Download', this.fileName);
      that.downloadingCurrent = true;
    }
    
    let fileDetails = {
      fileName: this.fileName,
    };
    this.isDownloadProgress = true;
    var successCb = function (cbObject) {
      const currentTime = new Date().toLocaleTimeString("en-IN");
      console.log('Download started successfully ********************* at time', currentTime);
      that.ticket = cbObject.ticket;
      // console.log("Ticket: " + cbObject.ticket);
      that.startDownloadStatus(callback, fileDetails);
    };

    var failureCb = function (cbObject) {
      that.isDownloadProgress = false;
      that.downloadingCurrent = false;
      that.percentage = 0;
      fileDetails.errorCode = cbObject.errorCode;
      fileDetails.errorText = cbObject.errorText;
      callback(DownloadEnum.DOWNLOAD_ERROR, fileDetails);
    };
    let result;
    let filename

    if(nextFile !== undefined){
      result = this.getNextDownloadUrl(nextFile.url);
      filename = this.staticInternalPath + nextFile.fileName + '.mp4';
    }else{
      result = this.getDownloadUrl();
      filename = this.staticInternalPath + this.fileName + '.mp4';
    }
    var options = {
      action: 'start',
      source: result.url,
      destination: filename,
      httpOption: {
        maxRedirection: 5,
        timeout: 60000,
      },
    };
    // this.g_storage.copyFile(successCb, failureCb, options);
    this.g_storage.downloadFile(successCb, failureCb, options);
  };

  startDownloadStatus = (callback, fileDetails) => {
    this.downloadStatusInternal = setInterval(() => {
      this.getDownloadFileStatus(callback, fileDetails);
    }, 1000);
  }

  cancelDownloadInterval = () => {
    clearInterval(this.downloadStatusInternal);
    this.downloadStatusInternal = null;
    this.isDownloadProgress = false;
    this.percentage = 0;
    this.downloadingCurrent = false;
    console.log("Cleared download interval");
  }

  getDownloadFileStatus = (callback, fileDetails) => {
    const that = this;
    var options = {
        ticket: this.ticket
    };
    var successCb = function (cbObject) {
      console.log("Download file status " + cbObject?.status);
      if(cbObject.status == "downloading") {
        that.received = that.formatBytes(parseInt(cbObject.amountReceived));
        that.total = that.formatBytes(parseInt(cbObject.amountTotal));
        that.percentage = parseInt((cbObject.amountReceived/cbObject.amountTotal)*100);
        console.log("Download in progress", `${that.percentage} % Downloaded ${that.received} out of ${that.total}`);
      } else if(cbObject.status == "completed") {
        clearInterval(that.downloadStatusInternal);
        that.downloadStatusInternal = null;
        that.isDownloadProgress = false;
        that.percentage = 0;
        that.downloadingCurrent = false;
        const currentTime = new Date().toLocaleTimeString("en-IN");
        console.log("Download completed at",currentTime);
        callback(DownloadEnum.DOWNLOAD_COMPLETE, fileDetails);
      }
    };

    var failureCb = function (cbObject) {
      var errorCode = cbObject.errorCode;
      var errorText = cbObject.errorText;
      that.percentage = 0;
      console.log(" Error Code [" + errorCode + "]: " + errorText);
    };

    this.g_storage.getDownloadFileStatus(successCb, failureCb, options);
  }

  cancelDownload = (callback) => {
    console.log('Stop Video Download', this.fileName);
    const that = this;
    that.percentage = 0;
    var successCb = function () {
      console.log('Download Canceled');
      callback(DownloadEnum.DOWNLOAD_CANCELED);
    };

    var failureCb = function (cbObject) {
      console.log('Error Cancelling Download:::: Error Code [' + cbObject.errorCode + ']: ' + cbObject.errorText);
      callback(DownloadEnum.DOWNLOAD_CANCELED_ERROR);
    };
    var options = {
      action: 'cancel',
      ticket: that.ticket,
    };
    this.g_storage.downloadFile(successCb, failureCb, options);
  };

  listDownloadFiles = (onComplete) => {
    console.log(TAG, 'Listing cached files');
    const that = this;
    var successCb = function (cbObject) {
      var files = cbObject.files;
      if (files.length > 0) {
        that.offlineFilesList = files;
      } else {
        that.offlineFilesList = [];
      }
      console.log(TAG, `${that.offlineFilesList.length} files in cache`);
      if (onComplete) onComplete();
    };

    var failureCb = function (cbObject) {
      console.log(TAG, 'Error listing files: [' + cbObject.errorCode + '] ' + cbObject.errorText);
      if (onComplete) onComplete();
    };
    let listOption = {
      path: this.staticInternalPath,
    };

    console.log(TAG, 'Cache path:', listOption.path);
    this.g_storage.listFiles(successCb, failureCb, listOption);
  };

  /**
   * Startup check: if free space is below the 200 MB floor, delete oldest
   * files (regardless of playlist) until the floor is restored.
   */
  enforceFloor = (callback) => {
    const that = this;
    this.checkSpace((key) => {
      if (key === DownloadEnum.SPACE_AVAILABLE) {
        console.log(TAG, 'Startup floor check: OK');
        callback();
      } else {
        console.log(TAG, 'Startup floor check: below floor, evicting files');
        const floorBytes = MIN_FREE_STORAGE_MB * 1024 * 1024;
        that.evictForSpace((result) => {
          if (result === DownloadEnum.SPACE_FREED) {
            console.log(TAG, 'Startup floor restored after eviction');
          } else {
            console.log(TAG, 'Startup floor: cannot restore - no files left to evict');
          }
          callback();
        }, floorBytes, true);
      }
    });
  };

  /**
   * Age-based eviction: delete oldest file, recheck space, repeat.
   * When ignoreProtected is false (default), skips current playlist files.
   * When ignoreProtected is true (startup floor), deletes anything.
   * Calls back with SPACE_FREED or SPACE_NOT_FREED.
   */
  evictForSpace = (callback, floorBytes, ignoreProtected) => {
    const that = this;

    let candidates;
    if (ignoreProtected) {
      candidates = this.offlineFilesList.slice();
    } else {
      candidates = this.offlineFilesList.filter((f) => {
        const id = f.name.replace('.mp4', '');
        return !this.protectedIds.has(id);
      });
    }

    if (candidates.length === 0) {
      console.log(TAG, ignoreProtected
        ? 'Eviction: no files left to delete'
        : 'Eviction: no candidates - all files are protected');
      callback(DownloadEnum.SPACE_NOT_FREED);
      return;
    }

    // Oldest file is first in array (SCAP listFiles order)
    const oldest = candidates[0];
    console.log(TAG, `Evicting oldest: ${oldest.name}`);

    const options = { file: this.staticInternalPath + oldest.name };

    this.g_storage.removeFile(
      function successCb() {
        const idx = that.offlineFilesList.indexOf(oldest);
        if (idx !== -1) that.offlineFilesList.splice(idx, 1);
        console.log(TAG, `Evicted: ${oldest.name} (${that.offlineFilesList.length} files remain)`);

        // Recheck space after eviction
        that.checkSpace((key) => {
          if (key === DownloadEnum.SPACE_AVAILABLE) {
            callback(DownloadEnum.SPACE_FREED);
          } else {
            // Still not enough, try evicting another
            that.evictForSpace(callback, floorBytes, ignoreProtected);
          }
        });
      },
      function failureCb(cbObject) {
        console.log(TAG, `Eviction failed for ${oldest.name}: [${cbObject.errorCode}] ${cbObject.errorText}`);
        callback(DownloadEnum.SPACE_NOT_FREED);
      },
      options
    );
  };

  /* Test purposes
  checkFileExists = (callback,nextFile) => {
    console.log("Check test file exists")
    let check = {};
    
    if(nextFile !== undefined){
      check.path = this.staticInternalPath + nextFile.fileName + '.mp4'
      check.index = nextFile.currentIndex
      check.url = nextFile.url
      check.fileName = nextFile.fileName
    }
    else{
      check.path = this.staticInternalPath + this.fileName + '.mp4'
      check.fileName = this.fileName
    }

    setTimeout(() => {
      callback(DownloadEnum.FILE_EXISTS, check);
    },2000)
  };*/
  check4KResolution = () => {
    const that = this;
    let width = window.innerWidth;
    let height = window.innerHeight;
    let pixelRatio = parseInt(window.devicePixelRatio);
    if(width*pixelRatio <= 1920 || height*pixelRatio <= 1920){
      that.quality4k = false;
    }else{
      that.quality4k = true;
    }
  };

  checkFileExists = (callback,nextFile) => {
    console.log('Check If File exists');
    const that = this;
    var successCb = function (cbObject) {
      var exists = cbObject.exists;
      console.log('The file exists: ', exists);
      let fileDetails = {
        fileName: that.fileName,
      };
      if (exists) {
        // that.deleteFile(that.fileName);
        callback(DownloadEnum.FILE_EXISTS, fileDetails);
      } else {
        callback(DownloadEnum.FILE_NOT_IN_LOCAL, fileDetails);
      }
    };
    var failureCb = function (cbObject) {
      let fileDetails = {
        fileName: that.fileName,
        errorCode: cbObject.errorCode,
        errorText: cbObject.errorText,
      };
      callback(DownloadEnum.FILE_NOT_IN_LOCAL, fileDetails);
      // console.log(' Error Code [' + errorCode + ']: ' + errorText);
    };

    let options = {};

    if(nextFile !== undefined){
      options.path = this.staticInternalPath + nextFile.id + '.mp4'
    }
    else{
      options.path = this.staticInternalPath + this.fileName + '.mp4'
    }
  
    console.log('Options : ', options);
    this.g_storage.exists(successCb, failureCb, options);
  };

  /*checkIfNextFileExists = (callback, nextFile) => {
    console.log('Check If Next File exists',nextFile.fileName);
    const that = this;
    var successCb = function (cbObject) {
      var exists = cbObject.exists;
      console.log('The file exists: ', exists);
      let fileDetails = {
        fileName: that.fileName,
      };
      if (exists) {
        // that.deleteFile(that.fileName);
        callback(DownloadEnum.FILE_EXISTS, fileDetails);
      } else {
        callback(DownloadEnum.FILE_NOT_IN_LOCAL, fileDetails);
      }
    };
    var failureCb = function (cbObject) {
      let fileDetails = {
        fileName: that.fileName,
        errorCode: cbObject.errorCode,
        errorText: cbObject.errorText,
      };
      callback(DownloadEnum.FILE_NOT_IN_LOCAL, fileDetails);
      // console.log(' Error Code [' + errorCode + ']: ' + errorText);
    };

    let options = {
      path: this.staticInternalPath + nextFile.fileName + '.mp4',
    };
    console.log('Options : ', options);
    callback(DownloadEnum.FILE_NOT_IN_LOCAL, "remove later")  //remove later
    //this.g_storage.exists(successCb, failureCb, options);
  };*/

  removeAllDownloads(callback) {
    console.log('Clearing Cache');
    const that = this;

    var successIn = function(cbObject){
      if(that.isUSB){
        let usb = window.usbName
        let options = {
          device: `${USB_NAME[usb.replace('/','')]}/`,
        };
        that.g_storage.removeAll(successCb, failureCb, options);
      }
      else{
        callback(DownloadEnum.CACHE_CLEAR_SUCCESS);
      }
    }

    var successCb = function (cbObject) {
      callback(DownloadEnum.CACHE_CLEAR_SUCCESS);
    };

    var failureCb = function (cbObject) {
      console.log('Error Deleting Files:::: Error Code [' + cbObject.errorCode + ']: ' + cbObject.errorText);
      callback(DownloadEnum.CACHE_CLEAR_ERROR);
    };

    var options = {
      device: 'internal', // This will remove all the files in the local storage.
    };

    this.g_storage.removeAll(successIn, failureCb, options);
  }

  removeAllDownloadsInternal(callback) {
    console.log('Clearing Cache Internal');
    const that = this;

    var successCb = function (cbObject) {
      callback(DownloadEnum.CACHE_CLEAR_SUCCESS);
    };

    var failureCb = function (cbObject) {
      console.log('Error Deleting Files:::: Error Code [' + cbObject.errorCode + ']: ' + cbObject.errorText);
      callback(DownloadEnum.CACHE_CLEAR_ERROR);
    };

    var options = {
      device: 'internal', // This will remove all the files in the local storage.
    };

    this.g_storage.removeAll(successCb, failureCb, options);
  }

  checkSpace = (callback) => {
    console.log(TAG, 'Checking storage space');
    const that = this;
    var successCb = function (cbObject) {
      // Always log internal storage
      const internalFreeMB = (cbObject.free / 1024).toFixed(1);
      const internalUsedMB = (cbObject.used / 1024).toFixed(1);
      console.log(TAG, `Internal storage: ${internalFreeMB} MB free / ${internalUsedMB} MB used`);

      let freeKB;
      if (that.isUSB) {
        let externals = cbObject.externalMemory;
        for (var uri in externals) {
          const usbFreeMB = (externals[uri].free / 1024).toFixed(1);
          const usbUsedMB = (externals[uri].used / 1024).toFixed(1);
          console.log(TAG, `USB storage (${uri}): ${usbFreeMB} MB free / ${usbUsedMB} MB used`);
          freeKB = externals[uri].free;
        }
        console.log(TAG, `Active storage: USB | Cache path: ${that.staticInternalPath}`);
      } else {
        freeKB = cbObject.free;
        console.log(TAG, `Active storage: INTERNAL | Cache path: ${that.staticInternalPath}`);
      }

      const freeMB = freeKB / 1024;
      // Store as bytes for checkFileHeadLength comparison
      that.availableStorage = freeKB * 1024;
      console.log(TAG, `Active free: ${freeMB.toFixed(1)} MB (floor: ${MIN_FREE_STORAGE_MB} MB)`);

      if (freeMB > MIN_FREE_STORAGE_MB) {
        callback(DownloadEnum.SPACE_AVAILABLE);
      } else {
        console.log(TAG, `Below ${MIN_FREE_STORAGE_MB} MB floor`);
        callback(DownloadEnum.SPACE_NOT_AVAILABLE);
      }
    };

    var failureCb = function (cbObject) {
      console.log(TAG, 'Space check error: [' + cbObject.errorCode + '] ' + cbObject.errorText);
      callback(DownloadEnum.SPACE_NOT_AVAILABLE);
    };
    this.g_storage.getStorageInfo(successCb, failureCb);
  };

  checkFreeSpace = (callback) => {
    console.log('Checking free and used space');
    const that = this;
    var successCb = function (cbObject) {
      that.appSpace.freeInternal = that.formatGB(cbObject.free);
      that.appSpace.usedInternal = that.formatGB(cbObject.used);
      console.log("Internal Storage free:",that.appSpace.freeInternal,"used",that.appSpace.usedInternal);
      let externals = cbObject.externalMemory;
      if (that.isUSB) {
        for (var uri in externals) {
          var external = externals[uri];          
          that.appSpace.freeExternal = that.formatGB(external.free);
          that.appSpace.usedExternal = that.formatGB(external.used);
        console.log("External Storage free:",that.appSpace.freeExternal,"used",that.appSpace.usedExternal);
        }
      }
      callback("Check Successful")
    };

    var failureCb = function (cbObject) {
      console.log('Error Checking Space::::: Error Code [' + cbObject.errorCode + ']: ' + cbObject.errorText);
      callback("Check Failed")
    };
    this.g_storage.getStorageInfo(successCb, failureCb);
  };

  restartDevice = () => {
    let options = {};
    options.powerCommand = Power.PowerCommand.REBOOT;

    var successCb = function () {
      console.log("Reboot success")
    }

    var failureCb = function (cbObject) {
      var errorCode = cbObject.errorCode;
      var errorText = cbObject.errorText;
  
      console.log("Error Code [" + errorCode + "]: " + errorText);
    }
    
    this.power.executePowerCommand(successCb, failureCb, options);
  };

  /*addUSBAttachEventListener() {
    const that = this;
    this.custom.Signage.addUSBAttachEventListener(
      function successCallback(successObject) {
          if (successObject.deviceList.length > 0) {
            that.getUSBInformation();
          }
      },
      function failureCallback(failureObject) {
          console.error('[' + failureObject.errorCode + '] ' + failureObject.errorText)
      }
    );
  };*/
}
